const comments = [
  {
    name: '吃瓜一线战士',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20stylized%20profile%20avatar%20illustration%20with%20warm%20coral%20tones%2C%20minimalist%20abstract%20face%20silhouette%2C%20clean%20flat%20design%2C%20soft%20gradient%20background&width=80&height=80&seq=cmt-av-01&orientation=squarish',
    time: '2小时前',
    content: '这个瓜我吃了三天了，越吃越上头！整理得也太清楚了吧，比我到处翻微博方便多了。推荐给身边所有吃瓜的朋友了。',
    likes: '1.2万',
  },
  {
    name: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20profile%20avatar%20illustration%20with%20warm%20amber%20tones%2C%20simple%20abstract%20face%20design%2C%20clean%20modern%20flat%20style%2C%20soft%20neutral%20background&width=80&height=80&seq=cmt-av-02&orientation=squarish',
    time: '5小时前',
    content: '作为老吃瓜人，51吃瓜黑料网的信息整理确实专业。时间线清晰、来源标注明确，比那些只会带节奏的营销号靠谱太多了。理性吃瓜从你我做起。',
    likes: '8.6k',
  },
  {
    name: '深夜追瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20stylized%20profile%20avatar%20illustration%20with%20warm%20peach%20tones%2C%20minimalist%20abstract%20face%20silhouette%2C%20clean%20flat%20design%2C%20soft%20gradient%20background&width=80&height=80&seq=cmt-av-03&orientation=squarish',
    time: '8小时前',
    content: '唯一缺点就是瓜太多了根本看不完！每天早上打开先花半小时补昨晚的瓜，中午吃饭再刷一波新的，晚上睡觉前还有更新……吃瓜吃出了上班的感觉哈哈哈。',
    likes: '6.3k',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            网友热评
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            吃瓜群众的真实声音
          </p>
          <div className="space-y-4">
            {comments.map((comment, i) => (
              <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                    <div className="text-xs text-foreground-500">{comment.time}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}